/* import __COLOCATED_TEMPLATE__ from './transfer-flow.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { MONEY_INPUT_ID } from '@banking/ui/utils/constants';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { updateQueryAction } from '@banking/ui/workflows/unified-activity/unified-activity';
let TransferFlow = (_class = class TransferFlow extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentTransfer", _descriptor, this);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "sentry", _descriptor3, this);
    _initializerDefineProperty(this, "savingsReporter", _descriptor4, this);
    _initializerDefineProperty(this, "plaidState", _descriptor5, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor6, this);
    _initializerDefineProperty(this, "isLoading", _descriptor7, this);
    _initializerDefineProperty(this, "page", _descriptor8, this);
    _initializerDefineProperty(this, "currentTransferEvents", _descriptor9, this);
  }
  goToBankLink(evt) {
    evt.preventDefault();
    if (this.args.showPlaidLink) {
      this.page = 'link-bank-info';
    } else {
      this.page = 'import-linked-bank';
    }
  }
  setPage(newPage) {
    this.page = newPage;
  }
  async goToConfirm() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    try {
      const transferEvents = await this.currentTransfer.estimateTransferEvents();
      this.currentTransferEvents = transferEvents;
    } catch (error) {
      // Ignore error attempting to estimate transfer events, confirm screen will
      // show a single estimated time
      this.sentry.captureException(error);
    } finally {
      this.isLoading = false;
      this.page = 'confirm';
    }
  }
  async completeTransfer() {
    if (this.isLoading) {
      return;
    }
    set(this, 'isLoading', true);
    try {
      await this.currentTransfer.createTransfer();
    } catch (error) {
      // TODO (SFSP-587) handle 401/403 and other expected errors
      this.sentry.captureException(error);
      this.page = 'error';
      this.isLoading = false;
      return;
    }
    try {
      await Promise.all([this.reloadAccounts(), this.reloadRecentActivity()]);
    } catch {
      // We throw away any errors encountered attempting to reload the customer's
      // recent activity and balances. Potentially we could show some sort of
      // error in recent activity or complete screen but for now this is better
      // than an error causing the transfer to appear failed.
    } finally {
      this.page = 'complete';
      this.isLoading = false;
    }
  }
  focusInput() {
    document.getElementById(MONEY_INPUT_ID)?.focus();
  }
  async initialize() {
    await this.currentTransfer.ready();
    this.isLoading = false;
  }
  reloadAccounts() {
    const accounts = [];
    if (this.currentTransfer.primaryAccount instanceof Account) {
      accounts.push(this.currentTransfer.primaryAccount);
    }
    if (this.currentTransfer.secondaryAccount instanceof Account) {
      accounts.push(this.currentTransfer.secondaryAccount);
    }

    // TODO: Reload via a batch-by-id endpoint would be more effective.
    const owners = [];
    accounts.forEach(({
      owner
    }) => {
      if (owner) {
        owners.push(owner);
      }
    });
    return this.bankingAccountApi.listAccounts(owners, {
      reload: true
    });
  }
  reloadRecentActivity() {
    if (this.currentTransfer.primaryAccount instanceof Account) {
      const sfsAccountId = this.currentTransfer.primaryAccount.metadata?.savingsAccount?.sfsAccountId;
      if (sfsAccountId) {
        if (this.savingsReporter.state.query.activityOwners.length > 0) {
          // Update the workflow with the same query to trigger a reload of
          // transactions.
          this.savingsReporter.emit(updateQueryAction(this.savingsReporter.state.query));
        }
      }
    }
    return null;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTransfer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savingsReporter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "plaidState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "page", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'enter-amount';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentTransferEvents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "goToBankLink", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToBankLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToConfirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToConfirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completeTransfer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "completeTransfer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype)), _class);
export { TransferFlow as default };